<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Store Sections</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6">
            <v-btn color="accent" small to="/new-store-section">
              <v-icon left dark>mdi-plus</v-icon>New Store Section
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="storeSections"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/store-section/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" text icon @click="openDeleteDialog(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- delete confirmation dialog -->
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-toolbar color="red" dense flat dark>
          <v-toolbar-title>Delete Store Section</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4">
          Are you sure you want to delete <strong>{{ selectedItem.Name }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red" dark :loading="deleteLoader" @click="deleteSection">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loader: false,
    deleteLoader: false,
    deleteDialog: false,
    selectedItem: {},
    zeroValue: 0,
    pageItems: 100,
    headers: [
      { text: "Name", value: "Name" },
      { text: "Action", value: "action" },
    ],
    storeSections: [],
  }),
  methods: {
    openDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    deleteSection() {
      const self = this;
      self.deleteLoader = true;
      this.$store
        .dispatch("remove", `/store-sections/${this.selectedItem.id}`)
        .then((res) => {
          self.deleteLoader = false;
          if (res.ResultCode == 1200) {
            self.deleteDialog = false;
            self.storeSections = self.storeSections.filter(
              (s) => s.id !== self.selectedItem.id
            );
          } else {
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.deleteLoader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    getStoreSections() {
      const self = this;
      this.$store
        .dispatch("get", `/store-sections`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.storeSections = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getStoreSections();
  },
};
</script>
